import type { WorkerDef } from './types';

/** Hireable miners — passive ore/s on the focused layer, scaling with multipliers. */
export const WORKERS: readonly WorkerDef[] = [
  {
    id: 'apprentice', name: 'Lehrling', icon: '👷', baseCost: 75, growth: 1.1,
    rate: 0.3, energy: 0,
    description: 'Günstige Hände mit Spitzhacke. Jeder Betrieb fängt so an.',
  },
  {
    id: 'miner', name: 'Erfahrener Kumpel', icon: '⛏️', baseCost: 1_200, growth: 1.12,
    rate: 2.5, energy: 0,
    description: 'Erfahren und unermüdlich. Starker Erzdurchsatz.',
    requires: { lifetimeEarnings: 2_000 },
  },
  {
    id: 'foreman', name: 'Steiger', icon: '🧑‍🏭', baseCost: 25_000, growth: 1.13,
    rate: 18, energy: -0.5,
    description: 'Führt eine Truppe und bedient schweres Gerät. Zieht Strom.',
    requires: { lifetimeEarnings: 5e4 },
  },
  {
    id: 'engineer', name: 'Bergbau-Ingenieur', icon: '👨‍🔬', baseCost: 4e5, growth: 1.14,
    rate: 130, energy: -1,
    description: 'Optimiert den Abbau mit ernsthafter Maschinerie.',
    requires: { lifetimeEarnings: 1e6, tech: 'automation' },
  },
  {
    id: 'android', name: 'Bergbau-Android', icon: '🤖', baseCost: 9e6, growth: 1.15,
    rate: 950, energy: -2,
    description: 'Schläft nie, klagt nie. Reine Förderung.',
    requires: { lifetimeEarnings: 2e7, tech: 'robotics' },
  },
] as const;

export const WORKER_BY_ID: Record<string, WorkerDef> = Object.fromEntries(
  WORKERS.map((w) => [w.id, w]),
);
